<div
  class="border-2 p-lg border-neutral-200 rounded-lg bg-white self-stretch w-[22.0625rem]"
  [class.min-h-[8.5rem]]="applyMinHeight()">
  <div
    class="flex gap-sm"
    [class.border-b]="
      step().assignees.length && (!positionName() || !hasEmptyCircle())
    "
    [class.border-neutral-200]="
      step().assignees.length && (!positionName() || !hasEmptyCircle())
    "
    [class.pb-lg]="
      step().assignees.length && (!positionName() || !hasEmptyCircle())
    ">
    <!-- step icon -->
    <div
      class="flex items-center justify-center bg-primary-50 rounded-sm size-8">
      @if (stepIndex() === 0) {
        <!-- first step icon -->
        <lib-arrow-left-icon
          [iconClass]="'size-5 text-primary-500 rotate-180'" />
      } @else if (positionsLength() && stepIndex() === positionsLength() - 1) {
        <!-- last step icon -->
        <lib-final-step-icon [iconClass]="'size-5 text-primary-500'" />
      } @else if (hasEmptyCircle()) {
        <!-- step with children icon -->
        <lib-empty-circle-icon [iconClass]="'size-8 text-primary-500'" />
      } @else {
        <!-- step with no children icon -->
        <lib-filled-circle-icon [iconClass]="'size-5 text-primary-500'" />
      }
    </div>

    <div class="flex flex-col gap-sm">
      <div
        class="w-[15.375rem] min-h-10 line-clamp-2 font-semibold text-neutral-900 text-sm"
        [class.mt-x-sm]="(positionName() || step().name).length <= 30"
        [class.mt-0]="(positionName() || step().name).length > 30">
        {{ positionName() || step().name }}
      </div>

      @if ((!positionName() || !hasEmptyCircle()) && !isFirstPosition()) {
        <div class="flex items-center gap-lg">
          <div class="flex items-center gap-x-sm">
            <lib-clock-icon [iconClass]="'size-4 text-neutral-500'" />

            <div class="text-neutral-700 font-medium text-xs2 relative">
              @if (step().sla.type === 'static') {
                {{ step().sla.value }}
              } @else {
                <span
                  libTooltip
                  [toolTipTemplate]="toolTipTemplate"
                  placement="top"
                  [hasCloseIcon]="false"
                  toolTipAction="mouseenter"
                  [position]="'absolute'"
                  [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top !w-80 !top-auto !bottom-[1.7rem] !end-1/2 !translate-x-1/2 rtl:!-translate-x-1/2'"
                  class="cursor-pointer underline">
                  {{ 'steps_diagram_tab_based_on_variable_label' | transloco }}

                  <ng-template #toolTipTemplate>
                    <div class="text-xs font-medium text-neutral-900">
                      {{ step().sla.variable.label }}
                    </div>
                  </ng-template>
                </span>
              }
            </div>
          </div>

          <div class="flex items-center gap-x-sm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.99969 8.66406C5.55969 8.88406 5.19302 9.21073 4.91969 9.6174C4.76635 9.85073 4.76635 10.1441 4.91969 10.3774C5.19302 10.7841 5.55969 11.1107 5.99969 11.3307"
                stroke="#6B7280"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M10.1406 8.66406C10.5806 8.88406 10.9473 9.21073 11.2206 9.6174C11.374 9.85073 11.374 10.1441 11.2206 10.3774C10.9473 10.7841 10.5806 11.1107 10.1406 11.3307"
                stroke="#6B7280"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M6.00065 14.6693H10.0007C13.334 14.6693 14.6673 13.3359 14.6673 10.0026V6.0026C14.6673 2.66927 13.334 1.33594 10.0007 1.33594H6.00065C2.66732 1.33594 1.33398 2.66927 1.33398 6.0026V10.0026C1.33398 13.3359 2.66732 14.6693 6.00065 14.6693Z"
                stroke="#6B7280"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M1.48633 5.3426L14.2997 5.33594"
                stroke="#6B7280"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <div class="text-neutral-700 font-medium text-xs2 relative">
              @if (!step().when) {
                {{ 'steps_diagram_tab_always_label' | transloco }}
              } @else {
                <span
                  libTooltip
                  [toolTipTemplate]="toolTipTemplate"
                  placement="top"
                  [hasCloseIcon]="false"
                  toolTipAction="mouseenter"
                  [position]="'absolute'"
                  [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top !w-80 !top-auto !bottom-[1.7rem] !end-1/2 !translate-x-1/2 rtl:!-translate-x-1/2'"
                  class="cursor-pointer underline">
                  {{ 'steps_diagram_tab_based_on_condition_label' | transloco }}

                  <ng-template #toolTipTemplate>
                    <div class="text-xs font-medium text-neutral-900">
                      {{ step().when }}
                    </div>
                  </ng-template>
                </span>
              }
            </div>
          </div>
        </div>
      }

      @if (
        step().tags.length &&
        step().assignees.length &&
        (!positionName() || !hasEmptyCircle())
      ) {
        <div class="flex flex-wrap items-center gap-x-sm">
          @for (tag of step().tags; track $index) {
            <div
              class="text-xs font-medium border-none px-sm rounded-3xl whitespace-nowrap"
              [class.bg-warning-100]="tag.value !== 'payment_technical'"
              [class.text-warning-700]="tag.value !== 'payment_technical'"
              [class.bg-primary-50]="tag.value === 'payment_technical'"
              [class.text-primary-700]="tag.value === 'payment_technical'">
              {{ tag.label }}
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (step().assignees.length && (!positionName() || !hasEmptyCircle())) {
    <ul class="flex flex-col pt-sm relative">
      @for (assignee of assigneeData(); track $index) {
        <li class="px-md py-x-sm flex items-center gap-x-sm">
          <div class="size-[0.325rem] bg-primary-100 rounded-full"></div>

          <div
            class="text-xs2 font-medium text-neutral-700 w-[17.5rem] min-h-4">
            @if (
              !isFirstPosition() || assignee.assignable_type !== 'variable'
            ) {
              {{
                'workflow_step_info_form_{' +
                  assignee.assignable_type +
                  '}_label' | transloco
              }}:
            }
            @if (assignee.name && assignee.name.length > 42) {
              <span
                libTooltip
                [toolTipTemplate]="assigneeTooltipTemplate"
                placement="top"
                [hasCloseIcon]="false"
                toolTipAction="mouseenter"
                [position]="'absolute'"
                [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top !w-80 !top-auto !bottom-[1.7rem] !end-1/2 !translate-x-1/2 rtl:!-translate-x-1/2'"
                class="cursor-pointer">
                {{ assignee.name | truncate: 42 }}

                <ng-template #assigneeTooltipTemplate>
                  <div class="text-xs font-medium text-neutral-900">
                    {{ assignee.name }}
                  </div>
                </ng-template>
              </span>
            } @else {
              {{ assignee.name || '' }}
            }
          </div>
        </li>
      }
    </ul>
  }
</div>
